export const EMPLOYMENT_STATUSES = {
    EMPLOYED: 'EMPLOYED',
    SELF_EMPLOYED: 'SELF_EMPLOYED',
    UNEMPLOYED: 'UNEMPLOYED',
    STUDENT: 'STUDENT',
    OTHER: 'OTHER',
    RATHER_NOT_SAY: 'RATHER_NOT_SAY'
};
